<template>
  <contact-page-content v-if="content">
    <template #title>
      <span v-html="content.title" />
    </template>

    <template #subtitle>
      <span
        class="prose leading-loose text-white"
        v-html="subtitleWithMaximizedEmojis"
      />
    </template>

    <template v-if="content.illustration" #append>
      <app-image
        alt=""
        class="aspect-video rounded-lg object-cover"
        :height="220"
        :src="content.illustration"
      />
    </template>
  </contact-page-content>
</template>

<script lang="ts" setup>
import emojiRegex from "emoji-regex";

import ContactPageContent from "~/pages/contact/_includes/components/content/contact-page-content.vue";
import { useContactPageNotionContent } from "~/pages/contact/_includes/composables/contact-page-notion-content.resolver";
import type { ContactFlowMetadata } from "~~/model/analytics.model";

const properties = defineProps<{
  metadata: ContactFlowMetadata;
}>();

const { getByMetadata } = await useContactPageNotionContent();

const content = computed(() => getByMetadata(properties.metadata));

const subtitleWithMaximizedEmojis = computed(() => {
  if (!content.value?.subtitle) return;

  try {
    const emojiMatches = content.value.subtitle
      .matchAll(emojiRegex())
      .toArray();

    return emojiMatches.reduce((subtitle, match) => {
      return subtitle.replaceAll(
        match[0],
        `<span class="text-2xl mr-1">${match[0]}</span>`,
      );
    }, content.value.subtitle!);
  } catch {
    /*
    Just add a try/catch here to avoid weird incompatibility errors in some cases :
    https://pollen-it.sentry.io/issues/6768085705/events/d63da0e9a3a243f7a1d7a79647da140c/
     */
  }
});
</script>
